import { useTranslation } from 'react-i18next';
import { Text } from '@hotjar/hotsauce';

interface SuccessScreenProps {
  children?: React.ReactElement;
}

export function SuccessScreen({ children }: SuccessScreenProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <Text as="h1" textType="header3" textColor="text_success">
        {t('activation:permission-required.request-sent-title')}
      </Text>
      <Text as="p" textType="body2">
        {t('activation:permission-required.request-sent-text')}
      </Text>
      {children}
    </>
  );
}
